import { Moment } from 'moment';
import * as moment from 'moment';

export default class Person {
  id: number;
  name: string;
  profilePicture?: string;
  personType: string;
  idExpirationDate?: Moment;
  surname: string;
  linkedinProfile?: string;
  displayName: string;
  percentCompleted?: number;

  constructor(entity: Person) {
    this.id = entity.id;
    this.name = entity.name;
    this.profilePicture = entity.profilePicture || undefined;
    this.personType = entity.personType;
    this.idExpirationDate = entity.idExpirationDate ? moment.utc(entity.idExpirationDate) : undefined;
    this.surname = entity.surname;
    this.linkedinProfile = entity.linkedinProfile || undefined;
    this.displayName = entity.displayName;
    this.percentCompleted = entity.percentCompleted || 0;
  }

}


// WEBPACK FOOTER //
// ./src/entities/Person.tsx